'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21(evaluator$17) {
  this.LV = null;
  this.LV = evaluator$17;
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21 as $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21 as $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21 };
$h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LV.h();
  return ($j_java$002elang$002e$002dObject.$isInt(v) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21, "samples.Sealed$package$$anon$6$$anon$17$$anon$21", ({
  qn: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21 as $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$21 };
